module.exports = __webpack_public_path__ + "img/resized-APP-0021-2.2591ee05.png";